import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DynamicEditComponent = ({ data, apiEndpoint, onSave, onClose }) => {
  const [formData, setFormData] = useState({ ...data });
  const [dropdowns, setDropdowns] = useState({
    locations: [],
    users: [],
    stages: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [locations, users, stages] = await Promise.all([
          axios.get(`${API_BASE_URL}/dropdown/locations`),
          axios.get(`${API_BASE_URL}/dropdown/users`),
          axios.get(`${API_BASE_URL}/dropdown/stages`),
        ]);
        setDropdowns({
          locations: locations.data,
          users: users.data,
          stages: stages.data,
        });
      } catch (err) {
        setError("Failed to fetch dropdown data.");
      }
    };
    fetchDropdownData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
  
    try {
      const projectIncharge = dropdowns.users.find(
        user => user.Username === formData.ProjectIncharge
      );
      
      const payload = {
        ...formData,
        ProjectIncharge: projectIncharge?.Username || formData.ProjectIncharge,
        EnteredByName: formData.EnteredByName || data.EnteredByName
      };

      await axios.put(`${apiEndpoint}/${data.ProjectID}`, payload);
      onSave();
    } catch (err) {
      console.error("Error response from API:", err.response?.data);
      setError(err.response?.data?.message || "Failed to update project.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow-md">
      <h2 className="text-lg font-semibold">Edit Project</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="text"
          name="ProjectName"
          value={formData.ProjectName}
          onChange={handleChange}
          placeholder="Project Name"
          className="border rounded px-4 py-2"
          required
        />
        <select
          name="LocationID"
          value={formData.LocationID}
          onChange={handleChange}
          className="border rounded px-4 py-2"
          required
        >
          <option value="">Select Location</option>
          {dropdowns.locations.map((loc) => (
            <option key={loc.LocationID} value={loc.LocationID}>
              {loc.LocationName}
            </option>
          ))}
        </select>
        <select
          name="ProjectIncharge"
          value={formData.ProjectIncharge}
          onChange={handleChange}
          className="border rounded px-4 py-2"
          required
        >
          <option value="">Select Project Incharge</option>
          {dropdowns.users.map((user) => (
            <option key={user.UserID} value={user.Username}>
              {user.Username}
            </option>
          ))}
        </select>
        <select
          name="StageID"
          value={formData.StageID}
          onChange={handleChange}
          className="border rounded px-4 py-2"
          required
        >
          <option value="">Select Stage</option>
          {dropdowns.stages.map((stage) => (
            <option key={stage.StageID} value={stage.StageID}>
              {stage.StageName}
            </option>
          ))}
        </select>
        <input
          type="email"
          name="MailID"
          value={formData.MailID}
          onChange={handleChange}
          placeholder="Mail ID"
          className="border rounded px-4 py-2"
          required
        />
        <div className="flex gap-4">
          <button
            type="submit"
            className="bg-yellow-500 text-white px-4 py-2 rounded"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default DynamicEditComponent;